import { render, staticRenderFns } from "./OrderGoodsTime.vue?vue&type=template&id=a75c2b26&"
import script from "./OrderGoodsTime.vue?vue&type=script&lang=js&"
export * from "./OrderGoodsTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports